const message = {
  ordernewinstallment:
    "Please generate at least ONE payment schedule and draft contract before this action.",
  getMessage: function (name) {
    return getMessage(name) || "";
  },
  getdialogsavesucce: function (format) {
    return `${format} Save success`;
  },
  getNotEmpty: function (format) {
    return `${format} cannot be empty.`;
  },
  getNotZero: function (format) {
    return `${format} cannot be zero.`;
  },
  dialogOk (format) {
    return `${format} updated!`;
  }
};

/**
 *
 * @param {*} name
 * @returns
 */
const getMessage = (name) => {
  const result = messageConfig.find((t) => t.name === name)?.value ?? "";
  return result;
};

const messageConfig = [
  {
    name: "savesuccess",
    value: "Save success",
  },
  {
    name: "mediadateoverflow1",
    value: "Date exceeds the Start Date or End Date of the original media.",
  },
  {
    name: "mediadateoverflow2",
    value: "Date exceeds the Start Date and End Date of the original media.",
  },
  {
    name: "diffplatform",
    value: "Unable to mix different platform media in this contract",
  },
  {
    name: "diffoperator",
    value: "Unable to mix different operator media in this contract",
  },
  {
    name: "diffsubgroup",
    value: "Unable to mix different Subgroup Code media in this contract",
  },
  {
    name: "mediadaterequire",
    value: "Start and End date cannot be empty.",
  },
  {
    name: "postgtdate",
    value: "Post Date cannot greater than Start Date.",
  },
  {
    name: "depostltdate",
    value: "Depost Date cannot less than End Date.",
  },
  {
    name: "moneyerror",
    value: "Input incorrect.",
  },
  {
    name: "insufficientbalance",
    value: "Insufficient Balance.",
  },
  {
    name: "dialogproductionchange",
    value:
      "Cannot edit within 7 days before campaign start, please contact operation team for assistance.",
  },
  {
    name: "unitpricezero",
    value: "Unit Price cannot be zero.",
  },
  {
    name: "contactrequire",
    value: "Please select at least ONE Contact Person.",
  },
  {
    name: "validformrequire",
    value: "Please fill in mandatory field! ",
    description: "非空验证提示"
  },
  {
    name: "commissionnomatch",
    value:
      'Sum of " Nett Item Sum" & "Total Production Cost " is not equal to the sum of " Special Commission Arrangement (Media Cost & Production Cost)".',
  },
  {
    name: "contractvalid1",
    value: "Please complete previous teps first",
  },
  {
    name: "draftvalid1",
    value: "Insufficient data to generate draft contract.",
  },
  {
    name: "nocompletededit",
    value: "Please complete unfinished edits first.",
  },
  {
    name: "validmediarequire",
    value: "Please select at least ONE Media Item",
  },
  {
    name: "validmedianett",
    value: "Sum of “Nett Item Sum” is not equal to “Media Nett”.",
  },
  {
    name: "validservicefee",
    value: "Sum of “Service Fee” is not equal to “Sales Service Fee”.",
  },
  {
    name: "errornumber",
    value: "Input incorrect.",
  },
  {
    name: "mediachange",
    value: "Please double check and modify Internal Split as media item has changed.",
  },
  {
    name: "ordercategoryrequire",
    value: "Please select only 1 Business Category!",
  },
  {
    name: "paymentdetailrequire",
    value: "Please generate at least ONE payment schedule before this action.",
  },
  {
    name: "regeneratepsd",
    value: "Please regenerate as payment schedule has changed.",
  },
  {
    name: "payamountfull",
    value: "Schedule amount must smaller than contract total.",
  },
  {
    name: "scheduleperoidfull",
    value: "Schedule period must within campaign period."
  },
  {
    name: "mediaPlanNull",
    value: "Please select sales option."
  },
  {
    name: "validfDraftContractDate",
    value: "Please fill in mandatory field!"
  },
  {
    name: "selectedinstallment",
    value: "Please generate at least ONE installment payment schedule before this action."
  },
  {
    name: "noEdit",
    value: "Save order before this action.",
  },
  {
    name: "productionChange",
    value: "Production Change save succcess."
  },
  {
    name: "contractinfovalidator",
    value: "Please complete previous steps first",
    description: "Contract Info 验证"
  },
  {
    name: "salesPermission",
    value: "You have no permission. Please contact Sales Administrator."
  },
  {
    name: "salesPermission2",
    value: "You have no permission to issue contract on this business category.  Please contact Sales Administrator."
  },
];

module.exports = message;
